import _ from "lodash";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { TaskTypes } from "@/constants/task-types";
import { slices } from "@/constants/sliceNames";
import { organizationsNames } from "@/container/Organizations/organizationsNames";

export const HOYA_IDS = ["6118d76821dbf4a9b71425ee", "5ffb31d4ce55e483faefffc3", "612e053ab9fdbdf871a66913"];
export const NAGASAKA_IDS = ["miqHn1orJmJkuANhdB58"];

export function useGeneralizer(componentsMap, default_, { organization, userId } = {}) {
  const userInfo = useSelector((state) => state[slices.auth].userInfo);

  const isUserInfoLoaded = useMemo(() => {
    return !_.isEmpty(userInfo);
  }, [userInfo]);

  const user = useMemo(() => {
    if (!isUserInfoLoaded) return;

    if (userId) {
      return userId;
    } else {
      return userInfo.user_id;
    }
  }, [isUserInfoLoaded, userId, userInfo.user_id]);

  const orgName = useMemo(() => {
    if (!isUserInfoLoaded) return;

    if (organization) {
      return organization.toLowerCase();
    } else if (HOYA_IDS.includes(user)) {
      return [organizationsNames.hoya];
    } else if (NAGASAKA_IDS.includes(user)) {
      return [organizationsNames.nagasaka];
    } else {
      return userInfo.organization.toLowerCase();
    }
  }, [isUserInfoLoaded, organization, user, userInfo.organization]);

  if (!isUserInfoLoaded) return null;

  if (orgName in componentsMap) {
    return componentsMap[orgName];
  } else {
    return default_;
  }
}

const organizationsTaskTypes = {
  [organizationsNames.hoya]: TaskTypes.HOYA,
  [organizationsNames.nagasaka]: TaskTypes.NAGASAKA,
  // averroes: TaskTypes.HOYA,
};

/**
 *
 * @param {string} org
 */
export const getTaskTypes = (org, userId = null) => {
  const orgName = org.toLowerCase();
  if (userId && HOYA_IDS.includes(userId)) return organizationsTaskTypes[organizationsNames.hoya];
  if (userId && NAGASAKA_IDS.includes(userId)) return organizationsTaskTypes[organizationsNames.nagasaka];
  if (orgName in organizationsTaskTypes) return organizationsTaskTypes[orgName];
  else return TaskTypes.OBJECT_DETECTION; // default for now as it's the most used
};
